export const environment = {
  production: false,
  apiBaseUrl: 'https://aelak-api.aikyambiztech.com'
};
